(function () {
  function fixWpImageLinks() {
    if (!window.location.pathname.includes('/blogs/')) return;

    var anchors = document.querySelectorAll('a[href^="https://i0.wp.com/"]');
    var count = 0;

    anchors.forEach(function (anchor) {
      var img = anchor.querySelector('img');
      var oldUrl = anchor.href;
      var parsed = new URL(oldUrl);
      var cleanUrl = parsed.origin + parsed.pathname;

      var newImg = document.createElement('img');
      newImg.src = cleanUrl;
      newImg.loading = 'lazy';

      if (img) {
        // Anchor wraps an <img>: preserve its alt and class
        newImg.alt = img.alt && img.alt.trim() !== '' ? img.alt : deriveAlt(parsed.pathname);
        if (img.className) newImg.className = img.className;
      } else {
        // Empty anchor pointing directly to image URL
        newImg.alt = deriveAlt(parsed.pathname);
      }

      anchor.parentNode.replaceChild(newImg, anchor);

      console.log('[WP Image Fix] Replaced: ' + oldUrl + ' \u2192 ' + cleanUrl);
      count++;
    });

    if (count > 0) {
      console.log('[WP Image Fix] Total replaced: ' + count);
    }
  }

  function deriveAlt(pathname) {
    var filename = pathname.split('/').pop();
    // Strip extension
    filename = filename.replace(/\.[^.]+$/, '');
    // Strip size suffixes like -150x150, -300x200
    filename = filename.replace(/-\d+x\d+$/, '');
    // Replace dashes and underscores with spaces
    filename = filename.replace(/[-_]+/g, ' ').trim();
    return filename;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixWpImageLinks);
  } else {
    fixWpImageLinks();
  }
})();
